module.exports = __webpack_public_path__ + "static/media/19ESCAP20.23ba34d5.jpg";